import React from 'react';

function LaptopTools() {
    return (
        <div>
            <section className="privacy-policy-area terms-condition-area">
                <div className="container">
                    <div className="row row--30">
                        <div className="col-lg-1"></div>
                        <div className="col-lg-11">
                            <div className="privacy-policy terms-condition">
                                <div className="text-block">
                                    <h3 className="title"><span className="text-gradient">Laptop & Desktop Requirements for Cloud-Based Training </span></h3>
                                    <p >These requirements reflect what's necessary for students to participate effectively and take the training from beginning to end.</p>
                                </div>

                                <div className="text-block d-flex flex-column flex-md-row justify-content-between align-items-center">
                                    <div className="text-content mb-3 mb-md-0">
                                        <h4 className="title"><span className="text-gradient">Minimum Requirements </span></h4>

                                        <ul>
                                            <li><strong>Processor (CPU):</strong> Intel Core i3 (8th gen or newer), AMD Ryzen 3, or Apple M2 and above</li>
                                            <li><strong>Operating System:</strong> Windows 10 or newer, macOS 10.14 (Mojave) or newer, Ubuntu 20.04+</li>
                                            <li><strong>Memory (RAM):</strong> 8 GB or more</li>
                                            <li><strong>Storage (Hard Drive):</strong>  At least 50 GB of free space</li>
                                            <li><strong>Network:</strong> Good internet connection</li>
                                            <li><strong>Other (Recommended):</strong>  Webcam and microphone</li>
                                        </ul>
                                    </div>
                                    {/* <img
                                        src="/assets/images/others/undraw_code-thinking_0vf2.png"
                                        alt="Laptop Computers"
                                        className="img-fluid mb-3 mb-md-0" 
                                        style={{ width: '275px', height: 'auto' }}
                                    /> */}
                                </div>
                                <div className="text-block d-flex flex-column flex-md-row justify-content-between align-items-center">
                                    <div className="text-content mb-3 mb-md-0">
                                        <h4 className="title"><span className="text-gradient">Recommended Specifications </span></h4>
                                        <p>
                                            For a smoother experience, especially when multitasking or running local tools, we recommend:
                                        </p>

                                        <ul>
                                            <li><strong>Processor (CPU):</strong>   Intel Core i5 or Ryzen 5, or equivalent</li>
                                            <li><strong>Memory (RAM):</strong>  16 GB</li>
                                            <li><strong>Storage (Hard Drive):</strong>  At least 100 GB free</li>
                                            <li><strong>Network:</strong> Good internet connection</li>
                                        </ul>
                                        <p style={{ marginTop: "35px" }}>
                                            <strong><u>Important Note:</u></strong> Chromebooks and tablets are not suitable for this program.
                                        </p>                                  </div>
                                    {/* <img
                                        src="/assets/images/others/undraw_computer-files_7dj6 (1).png"
                                        alt="Desktop Computers"
                                        className="img-fluid mb-3 mb-md-0" // Ajout de marges pour le mobile
                                        style={{ width: '200px', height: 'auto' }}
                                    /> */}
                                </div>

                                <div className="text-block d-flex flex-column flex-md-row justify-content-between align-items-center">
                                    <div className="text-content mb-3 mb-md-0">
                                        <h4 className="title"><span className="text-gradient">Device Compatibility Notes </span></h4>
                                        <strong>If you are eager to take the RedHat certification Prep course we offer as a bonus in this training package, MAC with M1 chip laptops will not be suitable due to compatibility issues with virtualization tools required for that course.</strong>

                                    </div>
                                    {/* <div style={{ display: 'flex' }}>
                                        <img
                                            src="/assets/images/others/undraw_algorithm-execution_rksm (1).png"
                                            alt="Apple Computers"
                                            className="img-fluid  " // Ajout de marges pour le mobile
                                            style={{ width: '200px', height: '150px', objectFit: 'cover' }}
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LaptopTools;